<template>
    <div>
        <footer>
            <div>
                抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
            </div>
            <div>
                适龄提示：适合8岁（含）以上玩家娱乐 Copyright@2021-2022 HabbyGames all rights reserved
            </div>
            <div>
                审批文号：国新出审〔2024〕1758 号 出版物号：ISBN 978-7-498-13847-7
            </div>
            <div>
                <a href="https://www.lezuan.net/server.html" target="_target">游戏许可及服务协议</a> ｜<a
                    href="https://lezuan.net/pengpengGamePrivacy.html"
                    target="_target"
                    >游戏隐私保护指引</a
                >
            </div>
            <div>
                <a href="https://beian.miit.gov.cn/#/home" target="_blank">沪ICP备2021024078号-22A</a>
            </div>

        </footer>
    </div>
</template>

<script>
import Pc from '@/components/pc'
import Mobile from '@/components/mobile'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    data() {
        return {
            language: 'en',
            isMobile: false
        }
    },
    mounted() {
        this.checkIfMobile();
    },
    methods: {
        // 区分移动还是pc
        checkIfMobile() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            this.isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        },
    }
}
</script>


<style lang="less" scoped>
footer {
    background: #252525;
    position: relative;
    padding: 5rem 0;
    color: #6a6969;
    font-size: 1.8rem;
    font-weight: 900;
    min-width: 1500px;
    a {
        color: #6a6969;
    }
    div {
        margin-top: 1.875rem !important;
    }
    p {
        display: none;
    }
}
@media screen and (max-width: 1024px) {
    footer {
        padding: calc(0.08 * 100%) 0;
        font-size: 1.8vw;
        width: 100%;
        div {
            margin-top: .5vh !important;
        }
        p {
            display: block;
            height: 0.8rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue